import { useEffect, useState } from 'react'
import '../App.css'
import { motion } from 'framer-motion'
export const Aboutus = () => {
    const [tabNote, setTabNote] =useState(aboutusNote)

    // const changeTabs = (tabNote) => {
    //         setTabNote(tabNote)
    // }

    return (
        <div className="about-us" >
            <div className="tabs">
                <button type="button" onClick={()=>setTabNote(aboutusNote)} >about us</button>
                <button type="button" onClick={()=>setTabNote(servicesNote)}>services</button>
                <button type="button" onClick={()=>setTabNote(missionNote)}>mission</button>
                <button type="button"onClick={()=>setTabNote(visionNote)} >vission</button>
            </div>
            <div className="tabNotes">
                {tabNote}
            </div>
            
        </div>
    )
}



export const aboutusNote = () => {
    return (
        <>
            <h2 className='section-headers'>ABOUT US</h2>
            <hr />
            <p>Arthur International Agency, established in 2021, is a trusted and visionary organization
                dedicated to unlocking global opportunities for ambitious individuals with a strong
                focus on Asia, particularly China and India.</p>
            <p>We specialize in guiding students and professionals from Africa to two of the world’s
                most dynamic education and innovation hubs. Whether you’re looking to pursue a
                medical degree in China, engineering in India, or explore fully funded scholarships in top
                Asian universities, we are here to walk with you every step of the way.</p>
            <p>Our growing network of partner institutions, scholarship providers, and international
                consultants ensures that every client receives personalized, up-to-date, and culturally
                aware support from application to arrival.</p>
            <p>We believe that global dreams begin with the right information, mentorship, and access
                and that’s exactly what we provide.</p>
        </>
    )
}

const listStyle = {
    textAlign: 'left',
    maxWidth: '600px',
    margin: '0 auto 30px',
    padding: '0 20px'
  }
  const listItemStyle = {
    fontSize: '1.1rem',
    marginBottom: '12px',
    padding: '8px 0',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    position: 'relative',
    paddingLeft: '30px'
  }
export const servicesNote = () => {
    return (
        <>
            <h2 className='section-headers'>OUR SERVICES</h2>
            <hr className='hr' />
            {/* <ul>
                <li>Scholarship and Admission Support in China and India</li>
                <li>Student Visa Application Assistance</li>
                <li>University Selection and Career Counseling</li>
                <li>Travel Preparation and Relocation Advice</li>
                <li>Pre-departure Briefing and Language Orientation</li>
            </ul> */}
            <div style={listStyle}>
                <div style={listItemStyle}>
                  <span style={{ position: 'absolute', left: '0', color: '#4F46E5' }}>🎓</span>
                  Scholarship and Admission Support in China and India
                </div>
                <div style={listItemStyle}>
                  <span style={{ position: 'absolute', left: '0', color: '#4F46E5' }}>📋</span>
                  Student Visa Application Assistance
                </div>
                <div style={listItemStyle}>
                  <span style={{ position: 'absolute', left: '0', color: '#4F46E5' }}>🎯</span>
                  University Selection and Career Counseling
                </div>
                <div style={listItemStyle}>
                  <span style={{ position: 'absolute', left: '0', color: '#4F46E5' }}>✈️</span>
                  Travel Preparation and Relocation Advice
                </div>
                <div style={listItemStyle}>
                  <span style={{ position: 'absolute', left: '0', color: '#4F46E5' }}>🗣️</span>
                  Pre-departure Briefing and Language Orientation
                </div>
              </div>

            <p><em>Global Dreams, Local Roots</em></p>
        </>
    )
}


export const missionNote = () => {
    return (
        <>
            <h2 className='section-headers'>OUR MISSION</h2>
            <hr className='hr' />
            <p>To connect African students with life-changing academic opportunities in Asia,
                especially in China and India empowering them to compete and lead globally.</p>

             <p><em>Global Dreams, Local Roots</em></p>
        </>
    )
}

export const visionNote = () => {
    return (
        <>
            <h2 className='section-headers'>OUR VISION</h2>
            <hr className='hr' />
            <p>To become Africa’s leading agency for study-abroad solutions in Asia, creating a bridge
                of knowledge, culture, and growth between continents.</p>
                
             <p><em>Global Dreams, Local Roots</em></p>
        </>
    )
}